import { ILocation } from '../calculateDistance';

export default (): Promise<ILocation> =>
  new Promise((resolve, reject) => {
    // Check permissions for Geolocation
    if (navigator.permissions) {
      navigator.permissions
        .query({ name: 'geolocation' })
        .then(permissionStatus => {
          if (
            permissionStatus.state === 'granted' ||
            permissionStatus.state === 'prompt'
          ) {
            // User needs to be asked for permission if "prompt"
            navigator.geolocation.getCurrentPosition(
              position => {
                const { latitude, longitude } = position.coords;
                resolve({ lat: latitude, lng: longitude });
              },
              (error: GeolocationPositionError) => {
                switch (error.code) {
                  case error.PERMISSION_DENIED:
                    reject(new Error('Geolocation permission denied'));
                    break;
                  case error.POSITION_UNAVAILABLE:
                    reject(
                      new Error('Position unavailable (network/GPS issue)'),
                    );
                    break;
                  case error.TIMEOUT:
                    reject(new Error('Geolocation request timed out'));
                    break;
                  default:
                    reject(new Error('Unknown geolocation error'));
                }
              },
            );
          } else {
            reject(new Error('Geolocation permission denied'));
          }
        });
    } else {
      reject(new Error('Permissions API not supported'));
    }
  });
